import { format, parseISO } from "date-fns";
import { toZonedTime, fromZonedTime  } from "date-fns-tz";

export const defaultRows = 10;
export const rowsPerPageOptions = [10, 25, 50, 100, 150];
export const paginator = true;
export const scrollable = true;
export const emptyMessage = "No records found.";
export const tableStyle = { minWidth: "50rem" };
export const currentPageReportTemplate =
  "Showing {first} to {last} of {totalRecords} entries";
export const paginatorTemplate =
  "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown";

export function formatDateTime(isoString) {
  if (!isoString) {
    return null;
  }

  const date = parseISO(isoString);
  return format(date, "yyyy-MM-dd");
}
export function convertPstDateToUtcIso(date) {
  if (!date) return null;

  const pstDate = format(date, "yyyy-MM-dd") + " 00:00:00";

  return fromZonedTime(
    pstDate,
    "America/Los_Angeles"
  ).toISOString();
}
export function formatDateAndTimeFromUtcToPst(dateTimeString) {
  if (!dateTimeString || isNaN(Date.parse(dateTimeString))) {
    return null;
  }

  const pacificTimeZone = "America/Los_Angeles";

  if (!dateTimeString.endsWith("Z")) {
    dateTimeString += "Z";
  }

  const utcDate = parseISO(dateTimeString);
  const zonedDate = toZonedTime(utcDate, pacificTimeZone);

  const hours = zonedDate.getHours();
  const minutes = zonedDate.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 === 0 ? 12 : hours % 12;

  return (
    format(zonedDate, "yyyy-MM-dd") + ` ${displayHours}:${minutes} ${ampm}`
  );
}
export function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export const SwitchboardCustomerOptions = {
  WalmartIntercompany: 1,
  SamsClub: 2,
  TraderJoes: 3
};
export const showStatusOptions = {
  All: null,
  Pending: 1,
  Submitted: 2,
  Processed: 3,
  Failed: 4,
  Cancelled: 5
};
export const showStatusKeyValueOptions = {
  1: "Pending",
  2: "Submitted",
  3: "Processed",
  4: "Failed",
  5: "Cancelled"
};
export const ediFileContentShowOptions = {
  EDIFile: "EDIFile",
  EDIPurchaseOrder: "EDIPurchaseOrder"
};
export const mapEdiPurchaseOrderProperties = (ediPurchaseOrderDatas) => {
  try {
    return ediPurchaseOrderDatas.map((ediPurchaseOrderData) => ({
      ediFileId: ediPurchaseOrderData.fid,
      ediFileName: ediPurchaseOrderData.fn,
      ediFileCreatedDateUTC: ediPurchaseOrderData.fc,
      ediPurchaseOrderId: ediPurchaseOrderData.poid,
      poNumber: ediPurchaseOrderData.pon,
      deliveryDate: ediPurchaseOrderData.dd,
      vendorSequenceNumber: ediPurchaseOrderData.vsn,
      distributionCenterNumber: ediPurchaseOrderData.dcn,
      buyingPartyName: ediPurchaseOrderData.bp,
      supplierName: ediPurchaseOrderData.sn,
      actualFulfillmentRegion: ediPurchaseOrderData.ar,
      processingStatus: ediPurchaseOrderData.ps,
      isDuplicatePO: ediPurchaseOrderData.dpo,
      approvedBy: ediPurchaseOrderData.ab,
      ediPurchaseOrderLineItemsList: ediPurchaseOrderData.ls.map((item) => ({
        ediPurchaseOrderLineItemId: item.l,
        buyersItemId: item.b,
        sellersItemId: item.s,
        itemDescription: item.d
      }))
    }));
  } catch (error) {
    throw "Unable to Map EDI PO Object";
  }
};

export const orderTypeOptions = {
  EmailBody: 1,
  PDF: 2,
};

export const emailOrdersApprovalStatusOptions = {
  All: null,
  Pending: 1,
  Submitted: 2,
  Processed: 3,
  Failed: 4,
  Cancelled: 5,
  Approved: 6,
  Rejected: 7
};
export const emailOrdersApprovalStatusKeyValueOptions = {
  1: "Pending",
  2: "Submitted",
  3: "Processed",
  4: "Failed",
  5: "Cancelled",
  6: "Approved",
  7: "Rejected"
};
export const emailOrdersD365StatusOptions = {
  All: null,
  NA: "NA",
  Enqueued: "Enqueued",
  Dequeued: "Dequeued",
  Acked: "Acked",
  Preprocessing: "Preprocessing",
  PreProcessError: "PreProcessError",
  Pending: "Pending",
  Processing: "Processing",
  InProcess: "InProcess",
  Processed: "Processed",
  ProcessedWithErrors: "ProcessedWithErrors",
  FailedToCallGetStatusAPI: "FailedToCallGetStatusAPI"
};
export const emailBodyOrderTradingPartners = {
  TraderJoes: 1,
  TraderJoesEquinox: 2
};
export const pdfOrderTradingPartners = {
  WholeFoods: 1
};

export const processingStatusOptions = {
  All: null,
  Pending: 1,
  Approved: 2
};
export const processingStatusKeyValueOptions = {
  1: "Pending",
  2: "Approved"
};
export const automaticStatusOptions = {
  All: null,
  Automatic: 1,
  Manual: 2
};
export const creditInvoiceStatusOptions = {
  Confirm: 1,
  NotConfirm: 2
};
export const creditInvoiceStatusKeyValueOptions = {
  1: "Success",
  2: "Failed"
};
